<template>
  <v-container>
    <v-row>
      <v-col cols="6" id="invoice">
        <v-text-field
          type="number"
          v-model="invoice"
          :label="$t('invoice')"
          required
          outlined
          ref="invoice"
          v-on:keyup="copyAmount"
          v-on:keyup.enter="focusDesiredAmount"
        >
          <template slot="append">{{ currentCurrency }}</template>
        </v-text-field>
      </v-col>
      <v-col cols="6" v-if="valid" id="desired-amount">
        <v-text-field
          type="number"
          v-model="desiredAmount"
          :label="$t('recommended_amount')"
          required
          outlined
          ref="desiredAmount"
        >
          <template slot="append">{{ currentCurrency }}</template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="!valid">
      <v-col cols="12">{{ $t('enter_invoice') }}</v-col>
    </v-row>

    <v-row v-if="valid">
      <v-col cols="6" class="text-center">
        {{ $t('tip') }} ({{ tipPercent }} %)
        <br />
        {{ tipCurrency }} {{ currentCurrency }} {{ $n(currentCurrency, 'currency') }}
      </v-col>
      <v-col cols="6" class="text-center" v-if="currentCurrency !== 'EUR'">
        {{ $t('recommended_amount') }}
        <br />
        {{ $t('in_eur') }} {{ amountInEuro }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" id="country-changer">
        <country-changer></country-changer>
      </v-col>
      <v-col cols="6" class="mt-2 text-center" id="buttons">
        <v-btn color="secondary" @click="sub" class="mr-2">-</v-btn>
        <v-btn color="secondary" @click="add" class="mr-2">+</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <flag-card></flag-card>
      </v-col>
    </v-row>

    <vue-tour></vue-tour>

    <v-footer
      absolute
      class="font-weight-medium"
      v-if="lastFetchDate && currentCurrency !== 'EUR'"
    >
      <v-col
        class="text-center"
        cols="12"
      >
       1 EUR = {{ currentRate }} {{ currentCurrency }} ({{ lastFetchDate }})
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
import CountryChanger from "../components/CountryChanger";
import FlagCard from "../components/FlagCard";
import VueTour from "../components/VueTour";
import { bus } from "../main";

export default {
  name: "Home",
  components: {
    CountryChanger,
    FlagCard,
    VueTour
  },
  data: () => ({
    invoice: null,
    desiredAmount: null,
    recommendedTip: null,
    currentCountry: null,
    currentCurrency: null,
    currentRate: null,
    userLang: null,
    resetInvoiceAfterTour: false,
    lastFetchDate: null,
  }),
  methods: {
    // Berechnnung auf 2 Nachkommastellen begrenzen
    copyAmount() {
      this.desiredAmount =
        Math.round(this.invoice * (this.recommendedTip / 100 + 1) * 100, 2) /
        100;
    },
    focusDesiredAmount() {
      this.$nextTick(() => this.$refs.desiredAmount.focus());
    },
    // Klick verändern Vorschlagswert auf ganzahligen Wert
    add() {
      this.desiredAmount = Math.round(this.desiredAmount + 1);
    },
    sub() {
      this.desiredAmount = Math.round(this.desiredAmount - 1);
    }
  },
  created() {
    bus.$on("changeCountry", (country, currency, recommendedTip, rate) => {
      (this.currentCountry = country), (this.currentCurrency = currency);
      this.recommendedTip = recommendedTip;
      this.currentRate = rate;

      this.copyAmount();
    });
    bus.$on("startTour", () => {
      if(null === this.invoice) {
        this.invoice = 10;
        this.copyAmount();
        this.resetInvoiceAfterTour = true;
      }
    });
    bus.$on("stopTour", () => {
      if(true === this.resetInvoiceAfterTour) {
        this.invoice = null;
        this.desiredAmount = null;
        this.resetInvoiceAfterTour = false;
      }
    });    
  },
  // Cursor steht zu Beginn im Rechnungsfeld
  mounted() {
    this.$refs.invoice.focus();
    this.userLang = navigator.language || navigator.userLanguage;

    if (localStorage.currencies) {
      const currencies = JSON.parse(localStorage.currencies);
      this.lastFetchDate = currencies.date;
    }
  },
  computed: {
    // Prozentberechnung auf 2 Nachkommastellen begrenzt
    tipPercent: function() {
      return (
        Math.round(((100 / this.invoice) * this.desiredAmount - 100) * 100) /
        100
      );
    },
    tipCurrency: function() {
      return new Intl.NumberFormat(this.userLang, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.desiredAmount - this.invoice);
    },
    // Statt den Berechnugen wird ein Hinweistext dargestellt, wenn eins der Eingabefelder leer/null
    valid: function() {
      if (isNaN(this.tipPercent)) {
        return false;
      }
      return true;
    },
    amountInEuro() {
      return new Intl.NumberFormat(this.userLang, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.desiredAmount / this.currentRate);
    }
  }
};
</script>

<style>
.v-text-field--full-width .v-input__prepend-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 20px;
}
.v-text-field__details {
  display: none;
}
</style>